import { render } from "./StudentChallengesView.vue?vue&type=template&id=3449b9ee"
import script from "./StudentChallengesView.vue?vue&type=script&lang=js"
export * from "./StudentChallengesView.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dashboard.epsasport-dev.apps.lu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__